import { Component, EventEmitter, inject, Output, signal, OnInit, OnDestroy } from '@angular/core';
import { HlmCardImports } from '@spartan-ng/helm/card';
import { HlmFieldImports } from '@spartan-ng/helm/field';
import { HlmInputImports } from '@spartan-ng/helm/input';
import { HlmSelectImports } from '@spartan-ng/helm/select';
import { HlmSpinnerImports } from '@spartan-ng/helm/spinner';
import { HlmButtonImports } from '@spartan-ng/helm/button';
import { HlmSeparatorImports } from '@spartan-ng/helm/separator';

import { FormBuilder, FormGroup, FormsModule, Validators, ReactiveFormsModule } from '@angular/forms';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { CommonModule } from '@angular/common';
import {
  lucideArrowLeft,
  lucideArrowRight,
  lucideCheck,
  lucideLockKeyhole,
  lucideRefreshCw,
  lucideTimer,
  lucideTriangleAlert,
  lucideX,
} from '@ng-icons/lucide';
import { Api } from '../../../services/api';
import { NotificationService } from '../../../services/notification-service';
import { SessionService } from '../../../services/session-service';
import { NetworkOptions, itemToString} from '../../../constants/shared-variables';
import { environment } from '../../../../environments/environment';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';

@Component({
  selector: 'app-payment-status-step',
  imports: [NgIcon, CommonModule, FormsModule, ReactiveFormsModule, HlmSeparatorImports,HlmButtonImports, HlmSpinnerImports, HlmSelectImports,HlmCardImports,HlmFieldImports,HlmInputImports],
  templateUrl: './payment-status-step.html',
  styleUrl: './payment-status-step.css',
  providers: [
    provideIcons({
      lucideLockKeyhole,
      lucideRefreshCw,
      lucideTimer,
      lucideTriangleAlert,
      lucideCheck,
      lucideX,
      lucideArrowLeft,
      lucideArrowRight,
    }),
  ]
})
export class PaymentStatusStep implements OnInit, OnDestroy {
  private fb = inject(FormBuilder);
  // private globalService = inject(GlobalService);
  // private readonly dialogService = inject(HlmDialogService);
  public sessionService = inject(SessionService);
  private apiService = inject(Api);
  private notificationService = inject(NotificationService);


  @Output() onContinue = new EventEmitter<any>

  paymentState = signal<'pending'|'success'|'failed'|null>(null)
  isCheckingPayment = signal<boolean>(false)
  private paymentStatusIntervalRef?: ReturnType<typeof setInterval>
  private paymentStatusTimeoutRef?: ReturnType<typeof setTimeout>


  retryPaymentStatusCheck(){
    this.startPaymentStatusCheck()
  }


  private startPaymentStatusCheck(){
    this.stopPaymentStatusCheck()
    this.checkPaymentStatusOnce()

    this.paymentState.set('pending')
    this.isCheckingPayment.set(true)

    this.paymentStatusIntervalRef = setInterval( ()=>{
      this.checkPaymentStatusOnce()
    },10000 )

    this.paymentStatusTimeoutRef = setTimeout( ()=>{
      this.isCheckingPayment.set(false)
      this.stopPaymentStatusCheck(false)

    },60000)
  }

  private stopPaymentStatusCheck( resetState:boolean = true){

    if(this.paymentStatusIntervalRef){
      clearInterval(this.paymentStatusIntervalRef)
      this.paymentStatusIntervalRef = undefined
    }

    if(this.paymentStatusTimeoutRef){
      clearTimeout(this.paymentStatusTimeoutRef)
      this.paymentStatusTimeoutRef = undefined
    }

    if(resetState){
      // this.paymentState.set('pending')
      this.isCheckingPayment.set(false)
    }
  }

  checkPaymentStatusOnce(){
    // api call here to get the response and stop
    this.checkPaymentStatus().then( (isSuccess)=>{
      console.log(this.paymentState())
      if(!isSuccess)return;

      this.stopPaymentStatusCheck()
    } )
  }

  async checkPaymentStatus(){

    const data = {serial_number: this.sessionService.formSubData()?.user?.serial_number}
    return new Promise<boolean>((resolve, reject) => {
      this.apiService.postData(data, environment.checkPaymentStatus).subscribe({
      next: (response: HttpResponse<any>) => {
        // this.isLoading.set(false);
        if (response.status === 200 || response.status === 201) {
          console.log('response body', response.body);

          if(response.body?.status === 'success'){
            switch (response.body?.payment_status) {
              case "successful":
                this.paymentState.set('success')
                resolve(true)
                break;
            case "failed":
              this.paymentState.set('failed')
              resolve(true)
              break;

              default:
                this.paymentState.set('pending')
                resolve(false)
                break;
            }
            // this.onNext()
            // this.notificationService.notify(response.body?.message,'success',{duration:3000,position:'top-right'} );
          }else{
            // this.notificationService.notify(response.body?.message,'warning',{duration:3000,position:'bottom-right'} );
            resolve(false)
          }


        }
       },
      error: (err: HttpErrorResponse) => {
        console.log('error error', err.error);
        resolve(false)
        const errorMessage = (err.error && err.error.message) ? err.error.message : 'Something went wrong';
        // this.notificationService.notify(errorMessage,'error',{duration:3000} );
      }
    });
    })
  }

  onBack(): void {
    this.onContinue.emit(false)
  }

  checkStatus(){
    this.onContinue.emit(true)
  }

  ngOnInit(): void {
    // start the periodic payment status checks when the component initializes
    if(!this.sessionService.formSubData()?.user?.serial_number){
      this.paymentState.set('failed')
      return;
    }
    this.startPaymentStatusCheck();
  }

  ngOnDestroy(): void {
    // clear any timers when the component is destroyed to avoid leaks
    this.stopPaymentStatusCheck(false);
  }
}
